export const ITEM_RESOURCE_CREDIT_FOR_FREE_TIER = 200;
export const USER_RESOURCE_CREDIT_FOR_FREE_TIER = 2; // every visitor to the homepage gets the same value, regardless of free tier version.
